export function request(userId) {
    return {
        type: 'BETSLIP_UPDATED',
        userId,
    };
}
